import { useGetIdentity } from "ra-core";

export type AppRole = "admin" | "team" | "client";

/** Role of the signed-in user, from the auth provider identity. */
export const useRole = (): { role?: AppRole; isPending: boolean } => {
  const { identity, isPending } = useGetIdentity();
  return { role: identity?.role as AppRole | undefined, isPending };
};

export const useIsClient = (): boolean => useRole().role === "client";
